module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div id="apexchat_scripts_multiple_choice_main_div_' +
((__t = (id)) == null ? '' : __t) +
'"\r\n    class="apexchat_message livechat_message_wrapper apexchat_question_type_custom_style_div ';
 if(userId == -1){ ;
__p += ' apexchat_system';
};

 if(userId == 0){ ;
__p += ' apexchat_visitor';
};

 if(userId > 0 || userId == -3){ ;
__p += ' apexchat_agent';
};
__p += ' apexchat_script_message_' +
((__t = (id)) == null ? '' : __t) +
'">\r\n    <div class="livechat_message_bubble_wrapper livechat_qt_bubble_wrapper livechat_ata_bubble_wrapper">\r\n\r\n        <div class="apexchat_question_type_single_col prechat_bubble radio livechat_message_bubble">\r\n            <div class="apexchat_speaker livechat_question_text">\r\n                <div id="apexchat_question_type_div_close_button_' +
((__t = (id)) == null ? '' : __t) +
'">\r\n                    <!--<div title="Close" id="apexchat-btn-skip-' +
((__t = (id)) == null ? '' : __t) +
'" class="apexchat_question_type_close_button"></div>-->\r\n                </div>\r\n                <!-- <div class="apexchat_text apexchat_speaker apexchat_participant_display_text"\r\n                    id="apexchat_participant_display_name">\r\n                    ' +
((__t = (participantDisplayName )) == null ? '' : __t) +
':&nbsp;\r\n                </div> -->\r\n                <div class="apexchat_speaker apexchat_participant_display_text" id="apexchat_participant_display_col">\r\n                </div>\r\n                <div class="apexchat_text apexchat_participant_display_text" tabindex="0"\r\n                    id="apexchat_participant_display_text">\r\n                    ' +
((__t = (text )) == null ? '' : __t) +
'\r\n                </div>\r\n                <!-- ' +
((__t = (participantDisplayName )) == null ? '' : __t) +
': ' +
((__t = (text )) == null ? '' : __t) +
' -->\r\n                <div id="apexchat_question_type_multiple_choice_file_div_' +
((__t = (id)) == null ? '' : __t) +
'" class="livechat_files_container">\r\n                </div>\r\n            </div>\r\n            <div id="apexchat_question_type_multiple_choice_options_div_' +
((__t = (id)) == null ? '' : __t) +
'"\r\n                class="apexchat_question_type_styled_input_container livechat_mc_options">\r\n                apexchat_options_div\r\n            </div>\r\n            <div class="apexchat_scroll_trigger">\r\n                <div class="apexchat_mc_ata_chevron">\r\n                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">\r\n                        <path d="M16.293 9.293 12 13.586 7.707 9.293l-1.414 1.414L12 16.414l5.707-5.707z" />\r\n                    </svg>\r\n                </div>\r\n                <span>Scroll</span>\r\n            </div>\r\n            <div id="apexchat-btn-update-' +
((__t = (id)) == null ? '' : __t) +
'" class="apexchat_question_type_update_container">\r\n                <span class="apexchat_question_type_update_button apexchat_ada_compliance">Update</span>\r\n            </div>\r\n            <!--<div class="apexchat_question_confirm_or_skip_padding" id="apexchat_question_type_div_confirm_button_' +
((__t = (id)) == null ? '' : __t) +
'">            \r\n                <br/><br /><br /><i>(Click okay to send your selection(s) or x if you do not want to answer.)</i>\r\n            </div>-->\r\n        </div>\r\n    </div>\r\n</div>';

}
return __p
}